import gql from 'graphql-tag';

export const Job = gql`
  query Job($organizationId: ID!, $jobId: ID!) {
    organization(organizationId: $organizationId) {
      job(jobId: $jobId) {
        id
        name
        state
        createdOn
        startedOn
        completedOn
        response
      }
    }
  }
`;
